const mockDetailedMeal = {
  food_name: "Placeholder Meal Name",
  brand_name: "Placeholder Brand Name",
  serving_qty: 1,
  serving_unit: "bottle",
  serving_weight_grams: 226,
  nf_metric_qty: 591,
  nf_metric_uom: "ml",
  nf_calories: 348,
  nf_total_fat: 2,
  nf_saturated_fat: null,
  nf_cholesterol: null,
  nf_sodium: 70,
  nf_total_carbohydrate: 39,
  nf_dietary_fiber: null,
  nf_sugars: null,
  nf_protein: 0,
  nf_potassium: null,
  nf_p: null,
  full_nutrients: [
    {
      attr_id: 203,
      value: 1,
    },
    {
      attr_id: 204,
      value: 2,
    },
    {
      attr_id: 205,
      value: 3,
    },
    {
      attr_id: 208,
      value: 4,
    },
    {
      attr_id: 307,
      value: 70,
    },
    {
      value: 150,
      attr_id: 262,
    },
  ],
  nix_brand_name: "Coke",
  nix_brand_id: "51db3801176fe9790a89ae0b",
  nix_item_name: "Diet Cola",
  nix_item_id: "51d2fae7cc9bff111580d8d8",
  metadata: {},
  source: 8,
  ndb_no: null,
  tags: null,
  alt_measures: null,
  lat: null,
  lng: null,
  photo: {
    thumb:
      "https://nutritionix-api.s3.amazonaws.com/5b5c17c429f162275dc922b0.jpeg",
    highres: null,
    is_user_uploaded: false,
  },
  note: null,
  class_code: null,
  brick_code: null,
  tag_id: null,
  updated_at: "2022-06-22T03:14:26+00:00",
  nf_ingredient_statement:
    "Carbonated Water, Caramel Color, Aspartame, Phosphoric Acid, Potassium Benzoate (to Protect Taste), Natural Flavors, Citric Acid, Caffeine.",
};

export default mockDetailedMeal;
